import { type TCollectionSuggestions as TApiCollectionSuggestions } from '@core/api'

import { type TCollectionSuggestions } from '@core/models'

import { convertCollectionSimple } from './convertCollectionSimple'

export const convertCollectionSuggestions = (
    apiSuggestions: TApiCollectionSuggestions,
): TCollectionSuggestions => {
    return {
        author: apiSuggestions.author.map(convertCollectionSimple),
        others: apiSuggestions.others.map(convertCollectionSimple),
    }
}
